function openCartDrawer(cartDrawer) {
  if (cartDrawer) {
    cartDrawer.classList.add('active');
  }
}

// Drawer + promo off: /cart redirects home and reopens drawer (India-style).
// Cart type "page": always allow /cart to load (promo flow on or off).
if (
  window.cartType === 'drawer' &&
  !window.cartPromoFlowEnabled &&
  window.location.href.indexOf('/cart') > -1
) {
  localStorage.setItem('cart-redirect', '1');
  window.location.href = '/';
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.cartType !== 'drawer') {
    localStorage.removeItem('cart-redirect');
    return;
  }

  if (localStorage.getItem('cart-redirect') === '1') {
    var cartDrawer = document.querySelector('body > cart-drawer');
    openCartDrawer(cartDrawer);
    localStorage.setItem('cart-redirect', '0');
  }
});
